<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <modal size="medium"
               v-if="productDescription != null"
               id="ModalProductDesc">

            <template v-slot:header>
                <h3 class="title">Descrição de Produto</h3>
            </template>

            <template v-slot:body>
                <div class="container-fluid-grid">
                    <div class="form-row">
                        <div class="col-12 form-group">
                            <label for="productDescId" class="required">Produto</label>
                            <select v-model="productDescription.product_id"
                                    id="productDescId"
                                    required
                                    @change="changeProduct"
                                    class="form-control form-control-sm"
                                    :class="{'is-invalid': errors.product_id}">
                                <option v-for="p in products"
                                        :disabled="disableProduct(p.id)"
                                        :key="p.id"
                                        :value="p.id">{{p.name}}</option>
                            </select>
                            <field-messages :errors="errors.product_id"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12 form-group">
                            <label for="productDescDesc" class="required">Descrição</label>
                            <textarea id="productDescDesc"
                                      required
                                      maxlength="4000"
                                      class="form-control form-control-sm"
                                      :class="{'is-invalid': errors.description}"
                                      v-model="productDescription.description"></textarea>
                            <field-messages :errors="errors.description"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12 form-group">
                            <label for="productDescSpecialCond">Condições Especiais</label>
                            <textarea id="productDescSpecialCond"
                                      class="form-control form-control-sm"
                                      maxlength="4000"
                                      v-model="productDescription.special_condition"></textarea>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <button type="button"
                        @click="save"
                        class="btn btn-sm btn-theme-1">
                    <svg-icon icon="save"/>
                    Salvar
                </button>
                <button type="button"
                        @click="productDescription = null"
                        class="btn btn-sm btn-dark">
                    <svg-icon icon="times"/>
                    Fechar
                </button>
            </template>
        </modal>
        <div class="container-fluid-grid" v-if="$appUtils.isDesktop()">
            <div class="row">
                <div class="col-12">
                    <table class="table table-bordered table-hover table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th>Produto</th>
                            <th>Descrição</th>
                            <th>Condição Especial</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(p,idx) in entity.product_descriptions_attributes"
                            :key="p.id"
                            class="line-item">
                            <td class="ellipsis c-p" @click="edit(p)">{{p.product.name}}</td>
                            <td class="ellipsis c-p" :title="p.description" @click="edit(p)">{{p.description}}</td>
                            <td class="p-r o-x-h" :title="p.special_condition">
                                <div class="c-p ellipsis" @click="edit(p)">{{p.special_condition}}</div>
                                <div class="actions btn-group btn-group-xs">
                                    <button type="button"
                                            class="btn btn-danger btn-xs"
                                            @click="destroy(idx)"
                                            title="Remover">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="grid-mobile"
             v-for="(p,idx) in entity.product_descriptions_attributes"
             :key="p.id">

            <span class="name ellipsis t-c">{{p.product.name}}</span>
            <span class="desc"><span class="label">Descrição</span><div v-html="p.description.trunc(144)"></div></span>
            <span class="special" v-if="!$appUtils.isEmpty(p.special_condition)">
                        <span class="label">Condições Especiais</span>{{p.special_condition.trunc(144)}}
                    </span>

            <div class="act">
                <button type="button"
                        class="btn btn-sm"
                        title="Modificar"
                        @click="edit(p)">
                    <svg-icon icon="pencil-alt"/>
                </button>

                <button type="button"
                        class="btn btn-sm"
                        title="Remover"
                        @click="destroy(idx)">
                    <svg-icon icon="trash-alt"/>
                </button>
            </div>
        </div>

        <div class="t-r" style="margin-right: 10px">
            <button type="button"
                    @click="add"
                    class="btn btn-sm btn-outline-primary"
            ><svg-icon icon="plus"/> Adicionar</button>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers as helper} from 'vuex'
    const modules = {
        products: null,
        customers: null
    };
    Object.keys(modules).forEach(k => modules[k] = helper(k));

    export default {
        name: "ProductsTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                productDescription: null,
                errors: {}
            }
        },
        methods: {
            ...modules.products.mapActions(['loadAll']),
            add() {
                this.loadAll()
                    .then(data => {
                        if (this.$appUtils.isArray(data) && data.length > 0) {
                            let prod = null;

                            for (let p of this.products) {
                                if (!this.disableProduct(p.id)) {
                                    prod = p;
                                    break;
                                }
                            }

                            if (prod)
                                this.productDescription = {
                                    product_id: prod.id,
                                    product: prod,
                                };
                        }
                    });
            },
            edit(prodDesc) {
                this.loadAll()
                    .then(() => {
                        this.productDescription = prodDesc
                    });
            },
            save() {
                this.errors = {};

                if (!this.productDescription.product_id) {
                    this.$set(this.errors, 'product_id', ['Campo obrigatório']);
                }

                if (this.$appUtils.isEmpty(this.productDescription.description)) {
                    this.$set(this.errors, 'description', ['Campo obrigatório']);
                }

                if (Object.keys(this.errors).length === 0) {
                    const filter = this.entity.product_descriptions_attributes.filter(p => p.product_id === this.productDescription.product_id);

                    if (filter.length === 0) {
                        this.entity.product_descriptions_attributes.push(this.productDescription);
                    }
                    this.productDescription = null;

                    this.$emit('onUpdateTabBadges');
                }
            },
            changeProduct() {
                const prod = this.products.findById(this.productDescription.product_id);
                this.$set(this.productDescription, 'product', prod);
            },
            disableProduct(id) {
                return this.entity.product_descriptions_attributes.filter(p => p.product_id === id).length > 0
            },
            destroy(idx) {
                this.$store.commit('addModal', {
                    title: this.$t('common.destroyItemTitle'),
                    size: 'small',
                    body: this.$t('common.destroyItemMessage'),
                    buttons: [{
                        type: 'ok', class: 'btn btn-danger btn-sm',
                        method: id => {
                            this.$store.commit('destroyModal', id);
                            const prodDesc = this.entity.product_descriptions_attributes[idx];

                            if (prodDesc.id) {
                                this.$appHttp.delete(`/v1/customers/destroy_product_description/${prodDesc.id}`)
                                    .then(() => {
                                        this.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);
                                        this.$delete(this.entity.product_descriptions_attributes, idx);
                                        this.$emit('onUpdateTabBadges');
                                    })
                                    .catch(err => {
                                        this.$appUtils.vibrate();
                                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar remover a descrição do produto...'}), this.$appStorage.getUser().name);
                                        console.error(err);
                                    })

                            } else {
                                this.$delete(this.entity.product_descriptions_attributes, idx);
                                this.$emit('onUpdateTabBadges');
                            }
                        }
                    }, {
                        type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)
                    }]
                });
            }
        },
        computed: {
            ...modules.products.mapGetters({products: 'all'})
        }
    }
</script>

<style lang="scss" scoped>

    .grid-mobile {
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: 1fr auto auto auto;
        grid-gap: 5px;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .label {
            display: block;
            font-weight: bold;
            font-size: .8em;
        }

        .name {
            text-align: center;
            font-weight: bold;
        }

        .special, .desc {
            font-size: .8em;
        }

        .act {
            text-align: right;

            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
